module.exports = __webpack_public_path__ + "img/suit-04.b98d024a.png";